const BLOCKED_WORDS = [
  // Common profanity
  'fuck', 'shit', 'ass', 'asshole', 'bitch', 'bastard', 'damn', 'dick',
  'piss', 'crap', 'cock', 'cunt', 'twat', 'wanker', 'bollocks', 'bugger',
  'prick', 'tit', 'tits', 'slut', 'whore', 'hoe', 'skank',
  'motherfucker', 'motherfucking', 'fucker', 'fucking', 'fucked', 'fucks',
  'shitty', 'shitting', 'bullshit', 'horseshit', 'dipshit', 'dumbass',
  'jackass', 'smartass', 'fatass', 'badass', 'kickass',
  'goddamn', 'goddam', 'dammit', 'damnit',
  'dickhead', 'dickweed', 'dickface',
  'bitchy', 'bitches', 'sonofabitch',
  'cocksucker', 'cocksucking',
  'cumshot', 'cum', 'jizz', 'spunk',
  'blowjob', 'handjob', 'rimjob',
  'dildo', 'vibrator',
  'pussy', 'pussies',
  'anus', 'butthole', 'arsehole', 'arse',
  'boob', 'boobs', 'boobie', 'boobies',
  'erection', 'boner',
  'orgasm', 'masturbate', 'masturbation', 'wank',
  'fellatio', 'cunnilingus',
  'queef', 'douche', 'douchebag',
  'fap', 'milf', 'gilf',

  // Racial slurs
  'nigger', 'nigga', 'niggers', 'niggas',
  'nig', 'nigg',
  'coon', 'coons', 'darkie', 'darky',
  'spic', 'spick', 'spik',
  'wetback', 'beaner',
  'chink', 'chinky', 'gook', 'gooks', 'zipperhead',
  'jap', 'japs',
  'kike', 'kikes', 'hebe', 'heeb',
  'raghead', 'towelhead', 'camel jockey', 'sandnigger',
  'paki', 'pakis',
  'redskin', 'injun',
  'cracker', 'honky', 'honkey', 'redneck',
  'gringo',
  'wop', 'dago', 'guinea', 'guido',
  'polack',
  'kraut',

  // Homophobic / transphobic slurs
  'fag', 'fags', 'faggot', 'faggots', 'faggy',
  'dyke', 'dykes',
  'homo', 'homos',
  'tranny', 'trannies', 'shemale', 'he-she', 'heshe', 'ladyboy',

  // Disability slurs
  'retard', 'retarded', 'retards',
  'spaz', 'spazz', 'spastic',
  'cripple', 'crippled',
  'mongoloid',

  // Religious slurs
  'christkiller',

  // Misc hateful
  'nazi', 'nazis', 'hitler',
  'whitepower', 'white power', 'heil',
  'kkk',
  'genocide',
  'incel',
];

const LEET_MAP: Record<string, string> = {
  '0': 'o',
  '1': 'i',
  '3': 'e',
  '4': 'a',
  '5': 's',
  '7': 't',
  '8': 'b',
  '@': 'a',
  '$': 's',
  '!': 'i',
  '+': 't',
};

function normalizeLeet(text: string): string {
  return text
    .split('')
    .map((ch) => LEET_MAP[ch] || ch)
    .join('');
}

function stripNonAlpha(text: string): string {
  return text.replace(/[^a-z\s]/g, '');
}

/**
 * Returns true if the text contains profanity or slurs.
 * Checks the raw lowercase text, a leet-speak-decoded version,
 * and a version with non-alpha characters stripped.
 */
export function containsProfanity(text: string): boolean {
  const lower = text.toLowerCase();
  const decoded = normalizeLeet(lower);
  const stripped = stripNonAlpha(decoded);

  const variants = [lower, decoded, stripped];

  for (const variant of variants) {
    for (const word of BLOCKED_WORDS) {
      const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const pattern = new RegExp(`\\b${escaped}\\b`, 'i');
      if (pattern.test(variant)) return true;
    }
  }

  return false;
}
